import { enumToOptions } from '@app/shared/helpers';
import { Country } from '@app/shared/models/contracts/enums/shared-enums';

export const COUNTRY_OPTIONS = enumToOptions(Country, undefined, true);
